let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bsoqQ")).then(() => parcelRequire('1hTxv'));